import { put, take, call } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { GET_VECTOR_CHARTS_CONFIGURATION_REQUEST } from '../types/vectorDataChartTypes';
import { setVectorConfigurationSuccess } from '../../../reducers/vectorConfigurationSlice';
import { VectorConfigurationApi } from '../../../api/lelyBackend/vectorConfigurationApi';
import withLoading from '../../../sagas/loadingSaga';

export default function* vectorConfigurationSaga(api: VectorConfigurationApi) {
  while (true) {
    yield take(GET_VECTOR_CHARTS_CONFIGURATION_REQUEST);
    yield* withLoading(function* () {
      yield call(getVectorConfiguration, api);
    });
  }
}

function* getVectorConfiguration(api: VectorConfigurationApi) {
  try {
    // TODO: go trough vector configuration request data and do correct typings
    const vectorConfigurationData: AxiosResponse<any> = yield call(
      api.getVectorConfiguration,
    );
    yield put(setVectorConfigurationSuccess(vectorConfigurationData.data));
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.error('Failed to get vector configuration:', error);
  }
}
